
const SSO = 'SSO';
const USER_PASSWORD = 'USER_PASSWORD';
const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
const CONFIRM_FORGOT_PASSWORD = 'CONFIRM_FORGOT_PASSWORD';
const SELECT_MFA_TYPE = 'SELECT_MFA_TYPE';
const SMS_MFA = 'SMS_MFA';
const SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';

export const CHALLENGE_NAMES = [
    SSO,
    USER_PASSWORD,
    NEW_PASSWORD_REQUIRED,
    CONFIRM_FORGOT_PASSWORD,
    SELECT_MFA_TYPE,
    SMS_MFA,
    SOFTWARE_TOKEN_MFA,
];


export default class Challenge
{

    // Challenge Names
    static SSO = SSO;
    static USER_PASSWORD = USER_PASSWORD;
    static NEW_PASSWORD_REQUIRED = NEW_PASSWORD_REQUIRED;
    static CONFIRM_FORGOT_PASSWORD = CONFIRM_FORGOT_PASSWORD;
    static SELECT_MFA_TYPE = SELECT_MFA_TYPE;
    static SMS_MFA = SMS_MFA;
    static SOFTWARE_TOKEN_MFA = SOFTWARE_TOKEN_MFA;

    // Valic Challenge Names
    static CHALLENGE_NAMES = CHALLENGE_NAMES;

    response = null;
    _challenge_name = null;
    challenge_value = null;

    constructor(challenge_name, challenge_value)
    {
        this.challenge_name = challenge_name;
        this.challenge_value = challenge_value;
    }

    /**
     * Create new instance of Challenge from a network response
     *
     * @param object response - the network response
     * 
     * @return Challenge
     */
    static fromResponse(response)
    {
        let new_challenge = new Challenge(response.ChallengeName, response.ChallengeValue);

        new_challenge.response = response;

        return new_challenge;
    }

    /**
     * Validate the challenge_name before persisting
     * 
     * @param string challenge_name
     * 
     * @return void
     */
    set challenge_name(challenge_name)
    {
        if (typeof challenge_name !== 'string') {
            throw new Error('challenge_name is not a string');
        }

        if (!CHALLENGE_NAMES.includes(challenge_name)) {
            throw new Error('Invalid challenge_name');
        }

        this._challenge_name = challenge_name;
    }

    get challenge_name()
    {
        return this._challenge_name;
    }

    /**
     * Get the challenge message if it exists
     * 
     * @return ?string
     */
    get message()
    {
        if (this.response && this.response.Message) {
            return this.response.Message;
        }

        return null;
    }

    /**
     * Get the challenge error if it exists
     * 
     * @return ?string
     */
    get error()
    {
        if (this.response && this.response.Error) {
            return this.response.Error;
        }

        return null;
    }

    /**
     * Get advanced security details
     * 
     * @return ?object
     */
    get advanced_security()
    {
        if (this.response && this.response.AdvancedSecurity) {
            return this.response.AdvancedSecurity;
        }

        return null;
    }

    /**
     * Get the challenge value if it exists
     * 
     * @param string key - challenge_value key
     * 
     * @return mixed
     */
    value(key)
    {
        if (key && this.challenge_value && this.challenge_value[key]) {
            return this.challenge_value[key];
        }

        return null;
    }

    /**
     * @return mixed
     */
    valueFromResponse(key)
    {
        if (key && this.response && this.response[key]) {
            return this.response[key];
        }

        return null;
    }

    /**
     * Perform an action for this challenge
     *
     */
    handle()
    {
        const handler_method = 'handle' + this.challenge_name;

        if (this[handler_method]) {
            return this[handler_method]();
        }

        return this.handleDEFAULT();
    }

    /**
     * If we dont need to do anything special just respond with obvious data
     *
     * @return Promise
     */
    handleDEFAULT()
    {
        return Promise.resolve({
            challenge_action: this.challenge_name,
            message: this.message,
            error: this.error,
            advanced_security: this.advanced_security,
        });
    }

    /**
     * Redirect the user to their SSO login page
     * 
     * @return Promise - empty as the location will redirect the user
     */
    handleSSO()
    {
        window.location.href = this.value('URL');
        return Promise.resolve({});
    }

    /**
     * @return Promise
     */
    handleUSER_PASSWORD()
    {
        return Promise.resolve({
            challenge_action: Challenge.USER_PASSWORD,
            message: this.message,
            error: this.error,
            advanced_security: this.advanced_security,
        });
    }

    /**
     * @return Promise
     */
    handleNEW_PASSWORD_REQUIRED()
    {
        return Promise.resolve({
            challenge_action: Challenge.NEW_PASSWORD_REQUIRED,
            session: this.valueFromResponse('Session'),
            error: this.error,
            message: this.message,
        });
    }

    /**
     * @return Promise
     */
    handleSELECT_MFA_TYPE()
    {
        return Promise.resolve({
            challenge_action: Challenge.SELECT_MFA_TYPE,
            challenge_value: this.valueFromResponse('MFAS_CAN_CHOOSE'),
            message: this.message,
            error: this.error,
            session: this.valueFromResponse('Session'),
        });
    }


    /**
     * @return Promise
     */
    handleSMS_MFA()
    {
        return Promise.resolve({
            challenge_action: Challenge.SMS_MFA,
            message: this.message,
            error: this.error,
            session: this.valueFromResponse('Session'),
        });
    }


    /**
     * @return Promise
     */
    handleSOFTWARE_TOKEN_MFA()
    {
        return Promise.resolve({
            challenge_action: Challenge.SOFTWARE_TOKEN_MFA,
            message: this.message,
            error: this.error,
            session: this.valueFromResponse('Session'),
        });
    }

}
